import { Spinner } from "@chakra-ui/react";
import { useState } from "react";
import { isRFQDraft, statusNameFormatter } from "utils/helpers";
import { Icon } from "assets/Icon";
import { getSlug } from "helpers/linkHelper";
import { RFX_STATUS } from "utils/constants";
import { Button } from "newui/components/Button";
import { navigate } from "@reach/router";
import { createRfq } from "actions/RFQ/rfqsAction";

export const RFQButtonActions = ({ project, rfq }) => {
	const [loadCreatingRfq, setLoadCreatingRfq] = useState(false);
	const rfqId = rfq?.id || null;
	const isHaveRFQ = rfqId !== null;
	const statusName = statusNameFormatter(rfq?.status);
	const isDraft = isRFQDraft(statusName);
	const isPastDeadline = statusName === RFX_STATUS.EVALUATION;

	const slug = getSlug(project?.name);

	const renderButtonText = () => {
		if (!isHaveRFQ)
			return (
				<>
					{" "}
					<Icon
						icon="plus"
						className="mr-1.5 [&>svg]:h-3 [&>svg]:w-3"
					/>
					Create RFx
				</>
			);
		if (!isPastDeadline && !isDraft) return "View RFx";
		if (isPastDeadline) return "View responses";
		if (isDraft) return "View Draft";
	};

	const handleClick = () => {
		if (!isHaveRFQ) {
			setLoadCreatingRfq(true);
			const redirectUrl = (id) => `../../rfx/${id}/create-rfx`;
			const data = {
				project_id: project.id,
				supplier_list_id: rfq?.supplierListId,
			};
			createRfq(data)
				.then((res) => {
					if (res) {
						navigate(redirectUrl(res.id), { state: { rfqData: res } });
						window.scrollTo(0, 0);
						setLoadCreatingRfq(false);
					}
				})
				.catch((err) => {
					setLoadCreatingRfq(false);
					console.log(err);
				});
		} else if (isDraft) {
			navigate(`../../rfx/${rfqId}/edit-rfx`);
			window.scrollTo(0, 0);
		} else {
			navigate(`../../rfx/${rfqId}/${slug}/all`);
			window.scrollTo(0, 0);
		}
	};

	return (
		<Button
			btntype={isHaveRFQ && "secondary"}
			onClick={handleClick}
			disabled={loadCreatingRfq}
			className="mx-auto"
			data-testId="create-rfq"
		>
			{loadCreatingRfq ? <Spinner /> : renderButtonText()}
		</Button>
	);
};
